export const ValueLoader = () => (
  <div className="h-4 w-10 bg-slate-200 animate-pulse rounded"></div>
);
